import React from 'react';
import { motion } from 'framer-motion';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
export function PrivacyPage() {
  return <div className="min-h-screen" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-303">
      <Navigation data-id="element-304" />

      <div className="pt-32 pb-20 px-4" data-id="element-305">
        <div className="max-w-4xl mx-auto" data-id="element-306">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-307">
            <h1 className="text-4xl sm:text-5xl font-bold mb-6" style={{
            color: 'var(--text-primary)'
          }} data-id="element-308">
              Privacy{' '}
              <span style={{
              color: 'var(--accent)'
            }} data-id="element-309">
                Policy
              </span>
            </h1>
            <p className="text-sm mb-8" style={{
            color: 'var(--text-muted)'
          }} data-id="element-310">
              Last updated:{' '}
              {new Date().toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>

            <div className="space-y-8" data-id="element-311">
              <Section title="1. Information We Collect" data-id="element-312">
                <p data-id="element-313">
                  We collect information you provide directly to us when you:
                </p>
                <ul data-id="element-314">
                  <li data-id="element-315">Request a free website demo</li>
                  <li data-id="element-316">Contact us through our forms</li>
                  <li data-id="element-317">Communicate with us via email, Telegram, or WhatsApp</li>
                </ul>
                <p data-id="element-318">
                  This may include your name, email address, phone number, and
                  business information.
                </p>
              </Section>

              <Section title="2. How We Use Your Information" data-id="element-319">
                <p data-id="element-320">We use the information we collect to:</p>
                <ul data-id="element-321">
                  <li data-id="element-322">Provide and deliver our web design services</li>
                  <li data-id="element-323">Create custom website demos for you</li>
                  <li data-id="element-324">Communicate with you about your project</li>
                  <li data-id="element-325">
                    Send you updates and promotional materials (with your
                    consent)
                  </li>
                  <li data-id="element-326">Improve our services and customer experience</li>
                </ul>
              </Section>

              <Section title="3. Cookies and Tracking" data-id="element-327">
                <p data-id="element-328">We use cookies and similar tracking technologies to:</p>
                <ul data-id="element-329">
                  <li data-id="element-330">Analyze site traffic and usage patterns</li>
                  <li data-id="element-331">Remember your preferences</li>
                  <li data-id="element-332">Improve site functionality</li>
                </ul>
                <p data-id="element-333">You can control cookies through your browser settings.</p>
              </Section>

              <Section title="4. Data Sharing" data-id="element-334">
                <p data-id="element-335">
                  We do not sell your personal information. We may share your
                  information with:
                </p>
                <ul data-id="element-336">
                  <li data-id="element-337">Service providers who assist in our operations</li>
                  <li data-id="element-338">Legal authorities when required by law</li>
                </ul>
              </Section>

              <Section title="5. Your Rights (GDPR)" data-id="element-339">
                <p data-id="element-340">If you are in the EU, you have the right to:</p>
                <ul data-id="element-341">
                  <li data-id="element-342">Access your personal data</li>
                  <li data-id="element-343">Correct inaccurate data</li>
                  <li data-id="element-344">Request deletion of your data</li>
                  <li data-id="element-345">Object to data processing</li>
                  <li data-id="element-346">Data portability</li>
                </ul>
                <p data-id="element-347">
                  Contact us at privacy@itmonsters.dev to exercise these rights.
                </p>
              </Section>

              <Section title="6. Data Security" data-id="element-348">
                <p data-id="element-349">
                  We implement appropriate security measures to protect your
                  personal information from unauthorized access, alteration, or
                  disclosure.
                </p>
              </Section>

              <Section title="7. Contact Us" data-id="element-350">
                <p data-id="element-351">For privacy-related questions, contact us at:</p>
                <p data-id="element-352">
                  Email: privacy@itmonsters.dev
                  <br data-id="element-353" />
                  Telegram: @itmonsters
                  <br data-id="element-354" />
                  WhatsApp: [Your Number]
                </p>
              </Section>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer data-id="element-355" />
      <CookieBanner data-id="element-356" />
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div className="rounded-2xl border p-6 sm:p-8" style={{
    borderColor: 'var(--border)',
    backgroundColor: 'var(--bg-secondary)'
  }} data-id="element-357">
      <h2 className="text-xl sm:text-2xl font-bold mb-4" style={{
      color: 'var(--text-primary)'
    }} data-id="element-358">
        {title}
      </h2>
      <div className="space-y-3 text-sm sm:text-base [&>ul]:list-disc [&>ul]:ml-6 [&>ul]:space-y-2" style={{
      color: 'var(--text-secondary)'
    }} data-id="element-359">
        {children}
      </div>
    </div>;
}